import * as t from 'io-ts';
import { BillingCardBrandC } from '../enums/billing-card-brand';

import { BillingPaymentStatusC } from '../enums/billing-payment-status';


export const BillingCardModelC = t.type(
  {
    id: t.string,
    expiryMonth: t.number,
    expiryYear: t.number,
    last4: t.string,
    brand: BillingCardBrandC,
    status: BillingPaymentStatusC,
  },
  'BillingCardForm');

export type BillingCardModel = t.TypeOf<typeof BillingCardModelC>;

